import styled from '@emotion/styled';
import { Typography } from 'components/Typography';
import palette from 'theme/palette';
import pxToEm from 'theme/pxToEm';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: ${pxToEm(13)};
  cursor: pointer;
`;

export const Cover = styled.div`
  width: ${pxToEm(48)};
  height: ${pxToEm(48)};
  border-radius: ${pxToEm(8)};
  background-color: ${palette.common.white};
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
`;

export const NumberOfElements = styled(Typography)`
  color: ${palette.grey[800]};
`;

export const Caption = styled(Typography)`
  color: ${palette.grey[800]};
`;
